// Pure builders/readers for the six GHL custom-payments iframe events.
// Field shapes are locked to docs/vendor/ghl/GoHighLevel-custom-payments-integration_2025-12_full.md
// §8.1 (ready), §8.3.1-3 (outcome events), §9.1 (setup_initiate_props + card-on-file outcomes).

export function buildProviderReadyPayload({ addCardOnFileSupported } = {}) {
  const payload = { type: 'custom_provider_ready', loaded: true };
  if (addCardOnFileSupported !== undefined) {
    payload.addCardOnFileSupported = addCardOnFileSupported;
  }
  return payload;
}

export function buildSuccessResponsePayload({ chargeId, subscriptionId, isSubscription } = {}) {
  const payload = { type: 'custom_element_success_response' };
  if (chargeId !== undefined) {
    payload.chargeId = chargeId;
  }
  if (isSubscription && subscriptionId) {
    payload.subscriptionId = subscriptionId;
    payload.isSubscription = true;
  }
  return payload;
}

export function buildErrorResponsePayload({ description, isSubscription } = {}) {
  const payload = {
    type: 'custom_element_error_response',
    error: { description },
  };
  if (isSubscription !== undefined) {
    payload.isSubscription = isSubscription;
  }
  return payload;
}

export function buildCloseResponsePayload({ isSubscription } = {}) {
  const payload = { type: 'custom_element_close_response' };
  if (isSubscription !== undefined) {
    payload.isSubscription = isSubscription;
  }
  return payload;
}

// Reads GHL's payment_initiate_props (§8.2), including the trial-subscription
// fallback where GHL sends amount 0/absent and the real amount lives in productDetails.
export function parsePaymentInitiateProps(messageData = {}) {
  const productDetails = messageData.productDetails;
  const mode = messageData.mode || 'payment';
  let amount = messageData.amount;

  if (mode === 'subscription' && (!amount || amount <= 0) && Array.isArray(productDetails) && productDetails.length > 0) {
    const firstProduct = productDetails[0];
    if (firstProduct.price && firstProduct.price.amount) {
      amount = firstProduct.price.amount;
    } else if (firstProduct.prices && firstProduct.prices.length > 0 && firstProduct.prices[0].amount) {
      amount = firstProduct.prices[0].amount;
    } else if (firstProduct.authorizeAmount && firstProduct.authorizeAmount > 0) {
      amount = firstProduct.authorizeAmount;
    }
  }

  return {
    amount,
    currency: messageData.currency,
    mode,
    orderId: messageData.orderId || messageData.order_id,
    transactionId: messageData.transactionId || messageData.transaction_id,
    subscriptionId: messageData.subscriptionId,
    locationId: messageData.locationId || messageData.location_id,
    productDetails,
    contact: messageData.contact,
    publishableKey: messageData.publishableKey,
  };
}

// Reads GHL's setup_initiate_props (§9.1).
export function parseSetupInitiateProps(messageData = {}) {
  return {
    contactId: messageData.contact?.id,
    // §9.1 contact.name：僅供顯示，非權威資料
    contactName: messageData.contact?.name,
    locationId: messageData.locationId,
    currency: messageData.currency,
    mode: messageData.mode,
    publishableKey: messageData.publishableKey,
    ssoKey: messageData.ssoKey || messageData.sso_token || messageData.ssoToken,
  };
}
